/* global reserve_shoe_ajax_url */
/* global ajax_nonce */
/* global multi_add_to_cart_ajax_url */

export default {
  init() {
    showSelectedSize();
    greyOutOfStock();
    getVariationId();
    initializeWolkyShops();
    changeColorLabel();
    //imageGallery();
    slideOnKeyPress();
    productInformationFlapOut();
    scrollToReviewBlock();
    addBulkVariationToCart();
    initializeDesktopImages();
    moveHelloRetailRecommendations();

    $('.reserve-input').on('input', function () {

      reserveValidation();
    });
    /*
    $('.reserve_button').on('click', function () {
      $('#reserve-fill-in').show();
      $('#reserve-success').hide();
      // $('#ws_reserve_color').val();
      // $('#ws_reserve_size').val();
      $('.modal-stock-location').text(($('.wolkyshop-city:visible').text()));
      $('.modal-background').css('display', 'block');
      $('.reserve-modal').show();
      $('#store-location').val($('.location:visible').data('location-code'));
      $('#reserve-product-id').val($('input[name="variation_id"]').val());
    });
    */
    initializeModalReserve();
    loadSizeFromLocalStorage();
    /*
    $('.close-reserve').on('click', function () {
      $('.modal-background').css('display', 'none');
    });
    */
    initializeColorSlider();

    initializeModalSizeSelection();
    initializeModalShoeSize();

    $('.wolkyshop_sizes_dropdown').select2({
      templateSelection: function(state) {
        if (!state.id) {
          return $('<span><strong>' + state.text + '</strong></span>');
        }

        const splitUSText = state.text.split('(US ');
        const splitUKText = state.text.split('(UK ');

        if (splitUSText.length === 2) {
          const euSize = splitUSText[0].trim();
          const additionalText = splitUSText[1].replace(')', '').trim();
          const [usSize, status] = additionalText.split('-').map(text => text.trim());
          let resultHtml = `<span><strong>${euSize}</strong> (US ${usSize})`;

          if (status) {
            resultHtml += ` <strong>- ${status}</strong>`;
          }

          resultHtml += '</span>';

          return $(resultHtml);
        }

        if (splitUKText.length === 2) {
          const euSize = splitUKText[0].trim();
          const additionalText = splitUKText[1].replace(')', '').trim();
          const [ukSize, status] = additionalText.split('-').map(text => text.trim());
          let resultHtml = `<span><strong>${euSize}</strong> (UK ${ukSize})`;

          if (status) {
            resultHtml += ` <strong>- ${status}</strong>`;
          }

          resultHtml += '</span>';

          return $(resultHtml);
        }

        return $('<span><strong>' + state.text + '</strong></span>');
      },
      templateResult: function(state) {
        if (!state.id) {
          return $('<span><strong>' + state.text + '</strong></span>');
        }

        const splitUSText = state.text.split('(US ');
        const splitUKText = state.text.split('(UK ');

        if (splitUSText.length === 2) {
          const euSize = splitUSText[0].trim();
          const additionalText = splitUSText[1].replace(')', '').trim();
          const [usSize, status] = additionalText.split('-').map(text => text.trim());
          let resultHtml = `<span><strong>${euSize}</strong> (US ${usSize})`;

          if (status) {
            resultHtml += ` <strong>- ${status}</strong>`;
          }

          resultHtml += '</span>';

          return $(resultHtml);
        }

        if (splitUKText.length === 2) {
          const euSize = splitUKText[0].trim();
          const additionalText = splitUKText[1].replace(')', '').trim();
          const [ukSize, status] = additionalText.split('-').map(text => text.trim());
          let resultHtml = `<span><strong>${euSize}</strong> (UK ${ukSize})`;

          if (status) {
            resultHtml += ` <strong>- ${status}</strong>`;
          }

          resultHtml += '</span>';

          return $(resultHtml);
        }

        return $('<span><strong>' + state.text + '</strong></span>');
      },
    });

    moveLabelOnImage();
  },
  finalize() {
  },
};


export var reserveValidation = () => {
  var reserveFirstName = $('#reserve-firstname').val();
  var reserveLastName = $('#reserve-lastname').val();
  var reservePhoneNumber = $('#reserve-phonenumber').val();
  var reserveEmail = $('#reserve-email').val();
  var reserveStreet = $('#reserve-street').val();
  var reserveHouseNumber = $('#reserve-housenumber').val();
  var reservePostalCode = $('#reserve-postalcode').val();
  var reserveCity = $('#reserve-city').val();

  if (reserveFirstName != '' && reserveLastName != '' && reservePhoneNumber != '' && reserveEmail != ''
    && reserveStreet != '' && reserveHouseNumber != '' && reservePostalCode != '' && reserveCity != '') {
    $('#reserve-submit').prop('disabled', false);
  } else {
    $('#reserve-submit').prop('disabled', true);
  }
}

export var changeColorLabel = () => {
  $('.variant-color').hover(function () {
    $('.selected_color').text($(this).attr('data-product'));
  }, function () {
    $('.selected_color').text($('.selected_color').attr('data-initial-color'));
  });

  $('.color-image').mouseenter(function () {
    let clone = $(this).find('img').clone();
    clone.addClass('variation-image-clone');
    clone.css(
      {
        position: 'absolute',
        top: 0,
        width: '100%',
        opacity: 1,
      }
    );
    clone.appendTo($('.ws-product-detail-image-slider'));
  });

  $('.color-image').mouseout(function () {
    $('.ws-product-detail-image-slider').find('.variation-image-clone').remove();
  });
}

export var checkSizeIsInStock = (size) => {

  let is_in_stock = false;
  let variations = $('form.variations_form').data('product_variations');
  $(variations).each(function () {
    if (this.attributes.attribute_pa_size == size) {
      is_in_stock = this.is_in_stock;
      return false;
    }
  });
  return is_in_stock;
}

export var checkSizeExists = (size) => {

  let size_exists = false;
  let variations = $('form.variations_form').data('product_variations');
  $(variations).each(function () {
    if (this.attributes.attribute_pa_size == size) {
      size_exists = true;
      return false;
    }
  });
  return size_exists;
}


export var loadSizeFromLocalStorage = () => {
  const menucheck = document.querySelector('#menu-hoofdmenu > .current-menu-ancestor > a');
  if (menucheck) {
    const checker = menucheck.dataset.wsTitle;
    let size = '';

    if (document.body.classList.contains('logged-in') && document.getElementById('size_is_set')) {
      size = document.getElementById('size_is_set').innerText;
    } else if (localStorage.getItem('size')) {
      size = localStorage.getItem('size');
    }

    if (size) {
      let gender = localStorage.getItem('gender');
      let is_in_stock = checkSizeIsInStock(size);

      if (is_in_stock) {
        // Only select and trigger change if the size is actually in stock and exists.
        $('.wolkyshop_sizes_dropdown').val(size).trigger('change');
      } else if (checkSizeExists(size) && checker === gender) {
        $('#sold_out_pa_size').css('display', 'inline-block');
        $('<span class="selected_size">' + size.replace('-', '.') + '</span>').appendTo('#pa_size_label');
      }
    }
  }
}

export var moveLabelOnImage = () => {
  $('.br_alabel').appendTo('.ws-product-image-slider');
}

export var initializeWolkyShops = () => {
  let elWolkyShops = $('.wolky-shops');
  let selectedValue = elWolkyShops.val();

  elWolkyShops.change(function () {
    $('.variation').css('display', 'none');
    if (elWolkyShops.val() && $('.variation_id').val()) {
      $('.modal-stock-location').text();
      $('.wolkyshop-stock').css('display', 'block');
      let elVariationLocation = $('.variation-' + $('.variation_id').val() + '-location-' + elWolkyShops.val());
      if (elVariationLocation.length) {
        elVariationLocation.css('display', 'block');
        $('.reserve_button').css('display', 'block');
      } else {
        $('.reserve_button').css('display', 'block');
        $('.no-location-stock').css('display', 'block');
      }

    } else {
      $('.reserve_button').css('display', 'none');
      $('.wolkyshop-stock').css('display', 'none');
      $('.variation-' + $('.variation_id').val() + '-location-' + elWolkyShops.val()).css('display', 'none');
    }

    $('.location').css('display', 'none');
    $('.location-' + elWolkyShops.val()).css('display', 'block');
  });

  if (selectedValue) {
    elWolkyShops.val(selectedValue).trigger('change');
  }

  //Mobile Reserve in shop
  $('.wolky-shops-container').on('click', function () {
    if ($(window).width() < 640) {
      if (elWolkyShops.is(':disabled')) {
        $('html, body').animate({scrollTop: $('.variation-content').offset().top}, 1000);
        $('.wolkyshop_sizes_dropdown').select2('open');
      }
    }
  });

  elWolkyShops.select2({
    templateResult: function (item) {
      if (typeof item.element === 'undefined') {
        return item.text;
      }


      let variationId = $('.variation_id').val();
      let elAmount = $('.variation-' + variationId + '-location-' + item.id + ' .amount');

      let amount = elAmount.text();
      if (!amount) {
        amount = '0';
      }

      let stock = $(item.element).data('stock-text');
      if (typeof stock !== 'undefined') {
        stock = stock.replace('${amount}', amount);
      } else {
        stock = '';
      }

      return $('<span class="wolky-shops-location-name">' + item.text + '</span><span class="wolky-shops-location-stock">' + stock + '</span>');
    },
  });
}

export var getVariationId = () => {
  let elVariationId = $('.variation_id');
  elVariationId.change(function () {
    let val = elVariationId.val();
    // Set product id on add button. Yes product id, it will fetch the parent of the variation in the ajax call.
    //$('.ajax_add_to_cart').data('product_id', val);
    $('.ajax_add_to_cart').each(function () {
      this.dataset.product_id = val;
      $('.wolkyshop_sizes_dropdown').select2('destroy');
      $('.wolkyshop_sizes_dropdown').select2({
        templateSelection: function(state) {
          if (!state.id) {
            return $('<span><strong>' + state.text + '</strong></span>');
          }

          const splitUSText = state.text.split('(US ');
          const splitUKText = state.text.split('(UK ');

          if (splitUSText.length === 2) {
            const euSize = splitUSText[0].trim();
            const additionalText = splitUSText[1].replace(')', '').trim();
            const [usSize, status] = additionalText.split('-').map(text => text.trim());
            let resultHtml = `<span><strong>${euSize}</strong> (US ${usSize})`;

            if (status) {
              resultHtml += ` <strong>- ${status}</strong>`;
            }

            resultHtml += '</span>';

            return $(resultHtml);
          }

          if (splitUKText.length === 2) {
            const euSize = splitUKText[0].trim();
            const additionalText = splitUKText[1].replace(')', '').trim();
            const [ukSize, status] = additionalText.split('-').map(text => text.trim());
            let resultHtml = `<span><strong>${euSize}</strong> (UK ${ukSize})`;

            if (status) {
              resultHtml += ` <strong>- ${status}</strong>`;
            }

            resultHtml += '</span>';

            return $(resultHtml);
          }

          return $('<span><strong>' + state.text + '</strong></span>');
        },
        templateResult: function(state) {
          if (!state.id) {
            return $('<span><strong>' + state.text + '</strong></span>');
          }

          const splitUSText = state.text.split('(US ');
          const splitUKText = state.text.split('(UK ');

          if (splitUSText.length === 2) {
            const euSize = splitUSText[0].trim();
            const additionalText = splitUSText[1].replace(')', '').trim();
            const [usSize, status] = additionalText.split('-').map(text => text.trim());
            let resultHtml = `<span><strong>${euSize}</strong> (US ${usSize})`;

            if (status) {
              resultHtml += ` <strong>- ${status}</strong>`;
            }

            resultHtml += '</span>';

            return $(resultHtml);
          }

          if (splitUKText.length === 2) {
            const euSize = splitUKText[0].trim();
            const additionalText = splitUKText[1].replace(')', '').trim();
            const [ukSize, status] = additionalText.split('-').map(text => text.trim());
            let resultHtml = `<span><strong>${euSize}</strong> (UK ${ukSize})`;

            if (status) {
              resultHtml += ` <strong>- ${status}</strong>`;
            }

            resultHtml += '</span>';

            return $(resultHtml);
          }

          return $('<span><strong>' + state.text + '</strong></span>');
        },
      });
    });

    if (val) {
      $('.reserve_button').prop('disabled', false);
      $('.wolky-shops').prop('disabled', false);
      $('.choose-size-option').remove();
      $('.choose-location-option').prop('selected', true);


      /*
      $('.wolky-shops option').each(function () {
        let el = $(this);
        let elAmount = $('.variation-' + val + '-location-' + el.attr('value') + ' .amount');
        console.log(el,elAmount);

        let amount = elAmount.text();
        if (!amount) {
          amount = '0';
        }

        let text = el.data('original');
        if (text) {
          text = text.replace('${amount}', amount);
        }

        el.text(text);
      });
      $('.wolky-shops').change();
      */
    } else {
      $('.wolky-shops').prop('disabled', true);
      $('.reserve_button').prop('disabled', true);
    }
    // console.log($('.variation_id').val());
    // $('.variation').css('display','none');
    // $('.variation-'+$('.variation_id').val()).css('display','block');
  });
}

export var showSelectedSize = () => {
  $('.wolkyshop_sizes_dropdown').change(function () {

    let val = $(this).val();
    if (val) {
      const queryChecker = document.querySelector('#menu-hoofdmenu > .current-menu-ancestor > a');
      let checker = 'default';

      if(queryChecker) {
        checker = queryChecker.dataset.wsTitle;
      }
      localStorage.setItem('gender', checker);
      localStorage.setItem('size', val);
    }
    $('#sold_out_pa_size').css('display', 'none');
    if ($('.selected_size')) {
      $('.selected_size').remove();

    }
    $('<span class="selected_size">' + $(this).val().replace('-', '.') + '</span>').appendTo('#pa_size_label');
  });
}

export var greyOutOfStock = () => {
  $('.wolkyshop_sizes_dropdown').change(function () {
    let colors = jQuery('.color-image');
    let selectedSize = $('select[name = "attribute_pa_size"]').val();

    if(selectedSize) {
      if (selectedSize.includes('-')) {
        selectedSize = selectedSize.replace('-', '.');
      }
      colors.each(function () {
        if (!jQuery(this).hasClass(selectedSize)) {
          jQuery(this).children('img').css('opacity', '0.2');
        } else {
          jQuery(this).children('img').css('opacity', '1');
        }
      })
    }
  });
}

export var initializeDesktopImages = () => {
  let wrapper = $('.product-detail-image-wrapper .wrapper');
  let sliderDiv = $('.ws-product-detail-image-slider');
  let navigation = $('.ws-product-detail-image-navigation');

  let sliderCount = 1;
  let slidersLoaded = 0;
  let images = wrapper.find('img');
  let imagesLoaded = 0;

  images.each(function (index, elem) {
    let img = new Image();
    img.onload = () => {
      imagesLoaded++;
      if (imagesLoaded >= images.length) {
        imagesDoneLoading();
      }
    };
    img.src = elem.src;
  });

  let imagesDoneLoading = function() {
    let slidersOnLoad = function(){
      slidersLoaded++;
      if (slidersLoaded >= sliderCount) {
        setTimeout(slidersDoneLoading, 0);
      }
    };

    sliderDiv.on('init', slidersOnLoad);
    sliderDiv.slick({
      waitForAnimate: false,
      infinite: true,
      speed: 0,
      arrows: true,
      prevArrow: '<div class="slick-prev"><div class="left-button"><i><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></i></div></div>',
      nextArrow: '<div class="slick-next"><div class="right-button"><i><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg></i></div></div>',
    });
  }

  let slidersDoneLoading = function() {
    let next = sliderDiv.find('.slick-next');
    let prev = sliderDiv.find('.slick-prev');
    let slickObj = sliderDiv.slick('getSlick');

    sliderDiv.find('video').each(function () {
      this.setAttribute('playsinline', '');
      this.setAttribute('autoplay', '');
    });

    function showHideNav() {
      let width = $(window).width();
      if (width >= 1024){
        next.hide();
        prev.hide();
      } else {
        prev.show();
        next.show();
      }
    }

    $(window).on('resize', function() {
      setTimeout(showHideNav, 300);
    });

    showHideNav();

    navigation.find('.wolky-img, .wolky-video').click(function () {
      let index = $(this).index();
      slickObj.slickGoTo(index);
    });

    sliderDiv.on('beforeChange', function() {
      sliderDiv.find('video').each(function () {
        this.pause();
      });
    });

    sliderDiv.on('afterChange', function(event, slick, currentSlide){
      navigation.find('.wolky-img, .wolky-video').removeClass('active');
      navigation.find('.wolky-img, .wolky-video').eq(currentSlide).addClass('active');

      let video = $(slick.$slides[currentSlide]).find('video');
      if (video.length) {
        video[0].play();
      }
    });

    setTimeout(() => sliderDiv.slick('slickGoTo', 0), 100);
    wrapper.addClass('slick-actually-initialized');
  }
}

export var initializeProductDetailImageLightboxSlider = () => {
  let imageBlock = $('.image-modal-clicker');
  let currentSlide = imageBlock.find('.slick-current').attr('data-slick-index');
  let lightboxSlider = $('.ws-product-detail-image-lightbox-slider');
  let navigationImages = $('.ws-product-detail-image-lightbox-navigation > .wolky-img, .ws-product-detail-image-lightbox-navigation > .wolky-video');

  if (lightboxSlider.is('.slick-initialized')) {
    if (currentSlide !== null) {
      lightboxSlider.slick('slickGoTo', currentSlide, true);
    }
    return;
  }

  if ($('.slick-slide:not(.slick-cloned)').length <= 1) {
    if (!$('#image-lightbox > .ws-product-detail-image-lightbox-slider').find('img').length) {
      $('.ws-product-detail-image-navigation > img').clone().appendTo($('#image-lightbox > .ws-product-detail-image-lightbox-slider'));
    }
  } else {
    lightboxSlider.slick({
      waitForAnimate: false,
      prevArrow: '<div class="slick-prev-lightbox product-detail-lightbox-arrow"><div class="prev-button-lightbox"><i><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></i></div></div>',
      nextArrow: '<div class="slick-next-lightbox product-detail-lightbox-arrow"><div class="next-button-lightbox"><i><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg></i></div></div>',
    });

    if (currentSlide !== null) {
      lightboxSlider.slick('slickGoTo', currentSlide, true);
    }

    navigationImages.mouseenter(function () {
      $('.ws-product-detail-image-lightbox-slider').slick('slickGoTo', $(this).index(), true);
    });

    navigationImages.eq(0).addClass('active');

    let previous = $('.slick-prev-lightbox');
    previous.next().insertBefore(previous);
    $('.product-detail-lightbox-arrow').wrapAll('<div class="slick-arrows-lightbox" />');

    lightboxSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
      navigationImages.removeClass('active').eq(nextSlide).addClass('active');

      lightboxSlider.find('video').each(function () {
        this.pause();
      });

      const nextVideo = $(slick.$slides[nextSlide]).find('video')[0];

      if (nextVideo) {
        console.log('Playing video in lightbox:', nextVideo);

        if (nextVideo.readyState >= 2) {
          nextVideo.play().catch(error => console.error('Lightbox video play error:', error));
        } else {
          nextVideo.oncanplay = function () {
            nextVideo.play().catch(error => console.error('Lightbox playback error:', error));
          };
        }
      }
    });

    setTimeout(() => {
      let firstVideo = lightboxSlider.find('.slick-active video')[0];
      if (firstVideo) {
        firstVideo.play().catch(error => console.error('First lightbox video play error:', error));
      }
    }, 500);
  }
};

export var imageGallery = () => {
  let imageBlock = $('.image-modal-clicker');
  let lightboxModal = $('#image-lightbox');

  if (!window.matchMedia('(max-width: 1024px)').matches) {
    /* Initializes the lightboxModal */
    lightboxModal.wsModal();
    lightboxModal.on('ws-modal:opened', function () {
      initializeProductDetailImageLightboxSlider()
    });

    /* Listener for main image click for opening the lightboxModal */
    imageBlock.click(function () {
      lightboxModal.wsModal('open');
    });
  }
}

export var initializeModalSizeSelection = () => {
  // Initialize size selection modal
  let modalSizeSelection = $('#ws-modal-size-selection');

  $('form.variations_form.cart').clone().appendTo(modalSizeSelection);

  modalSizeSelection.find('.wolkyshop-color-selection, .wolky-ref').remove();

  modalSizeSelection.find('[id]').each(function () {
    let el = $(this);
    el.attr('id', 'modal-size-selection-' + el.attr('id'))
  });

  modalSizeSelection.find('#modal-size-selection-pa_size_label').hide();

  modalSizeSelection.find('.wolkyshop_sizes_dropdown')
    .removeClass('wolkyshop_sizes_dropdown')
    .addClass('ws-size-selection-select')
    .change(function () {
      let val = $(this).val();
      $('.wolkyshop_sizes_dropdown').val(val).change();
    })
  ;
  $('.ws-size-selection-select').select2({
    dropdownParent: modalSizeSelection,
  });
  modalSizeSelection.wsModal();
  $('.variations_form').on('click', '.single_add_to_cart_button', function (event) {
    if ($(this).is('.disabled')) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      if ($('input[name=add-variations-to-cart]').val() !== 'true') {
        modalSizeSelection.wsModal('open');
      }
    }

    $( '.winkelwagen-popup' ).addClass( 'active' );
    setTimeout(hideCart, 5000);
    function hideCart() {
      $( '.winkelwagen-popup' ).removeClass( 'active' );
    }
  });

  $(document.body).on('added_to_cart removed_from_cart', function () { // event, fragments, cart_hash ) {
    modalSizeSelection.wsModal('close');
  });
}

export var initializeColorSlider = () => {
  let calculateSlider = function () {
    let colorContainerContent = $('.color-container-content');

    let shouldSlick = false;

    // Get enableSlick from css
    let enableSlick = 'false';
    if (colorContainerContent.length > 0) {
      enableSlick = getComputedStyle(colorContainerContent.get(0)).getPropertyValue('--ws-enable-slick').trim();
    }

    if (enableSlick === 'true') {
      let colorItems = null;
      if (colorContainerContent.is('.slick-initialized')) {
        colorItems = colorContainerContent.find('.slick-slide:not(.slick-cloned) a.color-image');
      } else {
        colorItems = colorContainerContent.find('a.color-image');
      }

      // Calculation is not perfect, but good enough i guess.
      let itemTotalWidth = colorItems.first().width() + parseInt(colorItems.first().css('margin-right'));

      if (itemTotalWidth * colorItems.length > colorContainerContent.width()) {
        shouldSlick = true;
      }
    }

    if (shouldSlick && !colorContainerContent.is('.slick-initialized')) {
      colorContainerContent.slick({
        lazyLoad: 'ondemand',
        slidesToShow: 1,
        variableWidth: true,
        prevArrow: '<div class="slick-prev"><div class="prev-button"><i><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"/></svg></i></div></div>',
        nextArrow: '<div class="slick-next"><div class="next-button"><i><svg xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 320 512"><path d="M278.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L210.7 256 73.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"/></svg></i></div></div>',
        initialSlide: 0,
        swipeToSlide: true,
        infinite: false,
      });
    }
    if (!shouldSlick && colorContainerContent.is('.slick-initialized')) {
      colorContainerContent.slick('unslick');
    }
  }

  let jWindow = $(window);

  //calculateSlider();
  jWindow.load(calculateSlider)
  jWindow.resize(calculateSlider);
}

export var initializeModalReserve = () => {
  let modalReserve = $('#ws-modal-reserve').wsModal();
  let loading = false;

  $('.reserve_button').on('click', function () {
    $('#reserve-fill-in').show();
    $('#reserve-success').hide();
    // $('#ws_reserve_color').val();
    // $('#ws_reserve_size').val();
    $('.modal-stock-location').text($('.wolkyshop-city:visible').text());
    modalReserve.wsModal('open');
    $('#store-location').val($('.location:visible').data('location-code'));
    $('#reserve-product-id').val($('input[name="variation_id"]').val());
  });

  $('#reserve_form').on('submit', function (e) {
    e.preventDefault();
    if (loading === true) {
      return;
    }
    loading = true;
    modalReserve.wsModal('setLoading', true);
    let form_data = $(this).serializeArray();
    form_data.push({'name': 'security', 'value': ajax_nonce});

    $.ajax({
      url: reserve_shoe_ajax_url.ajax_url, // Here goes the AJAX endpoint.
      type: 'post',
      data: form_data,
      success: function (response) {
        loading = false;
        modalReserve.wsModal('setLoading', false);
        console.log(response);
        if (response.status === 'success') {
          $('#reserve-fill-in').hide();
          $('.reserve-success-shop').text($('.wolkyshop-city:visible').text())
          $('#reserve-success').show();
        }
      },
      fail: function (err) {
        console.log(err);
      },
    });
  });
}

export var initializeModalShoeSize = () => {
  let sizeModal = $('#shoe-size-modal').wsModal();

  $('#size-chart-button').click(function () {
    sizeModal.wsModal('open');
  });
}

export var slideOnKeyPress = () => {
  let slider = null
  window.addEventListener('keydown', function (event) {
    if ($('body').hasClass('ws-modal-open')) {
      slider = $('.ws-product-detail-image-lightbox-slider');
    } else {
      slider = $('.ws-product-detail-image-slider');
    }
    if (event.defaultPrevented) {
      return;
    }

    switch (event.key) {
      case 'Left':
      case 'ArrowLeft':
        slider.slick('slickPrev', true);
        break;
      case 'Right':
      case 'ArrowRight':
        slider.slick('slickNext', true);
        break;
      default:
        return;
    }
    event.preventDefault();
  }, true);
}

export var productInformationFlapOut = () => {

  let retractableBlock = $('.retractable-block');

  nonRetractableDesktopBlock($(window).width());

  $(window).resize(function() {
    let pageWidth = $(window).width();
    nonRetractableDesktopBlock(pageWidth);
  });

  function nonRetractableDesktopBlock(pageWidth) {
    $('.non-retractable-desktop').each(function () {
      let title = $(this).find($('.retractable-block-title'));
      let content = $(this).find($('.retractable-block-content'));
      let up = title.find('.up');
      let down = title.find('.down');

      if (pageWidth >= 1024 || $(this).hasClass('non-retractable-mobile')) {
        content.show();
        down.hide();

        if($(this).hasClass('non-retractable-mobile')) {
          up.show();
        } else {
          up.hide();
        }
      }else {
        content.hide();
        up.hide();
        down.show();
      }
    });
  }

  retractableBlock.find('.retractable-block-title').click(function () {
    if (!$(this).parent().hasClass('non-retractable-desktop')) {
      show_hide($(this));
    }

    if ($(this).parent().hasClass('non-retractable-desktop') && $(window).width() < 1024) {
      show_hide($(this));
    }
  });

  function show_hide(element) {
    let up = element.find('.up')
    let down = element.find('.down');
    let content = $('.retractable-block-content');
    if (element.next(content).is(':hidden')) {
      element.next(content).slideDown(500);
      up.show();
      down.hide();
    } else {
      element.next(content).slideUp(500);
      up.hide();
      down.show();
    }
  }
}

export var scrollToReviewBlock = () => {
  $('.product-rating span').click(function () {
    $('html, body').animate({scrollTop: $('.review-block').offset().top}, 1000);
    $('.review-block').find('.retractable-block-title').trigger('click');
  });
}

export var addBulkVariationToCart = () => {
  if ($('input[name=add-variations-to-cart]').val() !== 'true') {
    return;
  }

  const qtyInputs = $('.qty_input');
  const qtyTotal = $('.wolkyQuantityTotal');
  const addToCartButton = $('.single_add_to_cart_button');

  addToCartButton.on('click', function(e) {
    e.preventDefault();
    let productsData = [];

    qtyInputs.each(function() {
      if($(this).val() > 0) {
        let variationProductId = $(this).attr('data-variation-id');
        let productId = $(this).attr('data-product-id');
        productsData.push({
          'product_id': productId,
          'variation_product_id': variationProductId,
          'qty': $(this).val(),
        });
      }
    });

    if(productsData.length > 0) {
      $.ajax({
        url: multi_add_to_cart_ajax_url.ajax_url,
        type: 'post',
        dataType: 'json',
        data: {
          'items' : Object.assign({}, productsData),
        },
        success : function(response) {
          if ( ! response ) {
            return;
          }

          $( document.body ).trigger( 'added_to_cart', [ response.fragments, response.cart_hash ] );
        },
      });
    }
  });

  qtyInputs.keyup(function () {
    $('.single_variation_wrap').find('.single_add_to_cart_button').removeClass('disabled').removeClass('wc-variation-selection-needed');
  });

  const calculateAndValidateTotal = function() {
    let total = 0;
    qtyInputs.each(function () {
      const el = $(this);
      const max = parseInt(el.attr('max'));
      let val = parseInt(el.val());

      if (val > max) {
        val = max;
      }
      if (val < 0) {
        val = 0;
      }

      el.val(val);

      total += val;
    });
    qtyTotal.html(total);

    if (total > 0) {
      addToCartButton.removeAttr('disabled');
    } else {
      addToCartButton.attr('disabled', true);
    }
  };
  qtyInputs.change(calculateAndValidateTotal);
  calculateAndValidateTotal();


}

export var moveHelloRetailRecommendations = function() {
  $(window).resize(function() {
    if ($(window).width() <= 1024) {
      $('#hello-retail').insertBefore('.mobile-breadcrumbs');//desktop
      $('#hello-retail').insertBefore('.mobile-breadcrumbs');//mobile

      $('#hello-retail').insertBefore('.mobile-breadcrumbs');//desktop
      $('#hello-retail').insertBefore('.mobile-breadcrumbs');//mobile

      $('#hello-retail').insertBefore('.mobile-breadcrumbs');//desktop
      $('#hello-retail').insertBefore('.mobile-breadcrumbs');//mobile

      $('#hello-retail').insertBefore('.mobile-breadcrumbs');//desktop
      $('#hello-retail').insertBefore('.mobile-breadcrumbs');//mobile
    }
    else if($(window).width() > 1024) {
      $('#hello-retail').insertAfter('.wrapper');//desktop
      $('#hello-retail').insertAfter('.wrapper');//desktop
      $('#hello-retail').insertAfter('.wrapper');//desktop
      $('#hello-retail').insertAfter('.wrapper');//desktop
    } else {
      $('#hello-retail').insertAfter('#hr-recom-k65e996b2db43ee5094033290');//mobile
      $('#hello-retail').insertAfter('#hr-recom-k655db17acb82e65958f0f943');//mobile
      $('#hello-retail').insertAfter('#hr-recom-k656705f583bff3712481f527');//mobile
      $('#hello-retail').insertAfter('#hr-recom-k65661386cc3b2047ef0a6ac4')//mobile
    }
  }).resize();
}
